import React from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

import colors from "../../design/colors";

/* **********************************
 * TYPES
 * 타입 정의
 ********************************** */
interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  /* **********************************
   * GLOBAL STATE
   * 전역 상태 및 전역 변수
   ********************************** */
  const location = useLocation();

  /* **********************************
   * LOCAL STATE
   * 컴포넌트 내부에서 사용하는 상태
   ********************************** */
  const noHeaderRoutes = ["/landing", "/payments"];
  const noSidebarRoutes = [
    "/login",
    "/signup",
    "/landing",
    "/find",
    "/payments",
  ];

  const noHeaderRegex = /^\/study\/exam\/\d+\/ing$/;
  const noSidebarRegex = /^\/study\/exam\/\d+\/ing$/;

  const noHeader =
    noHeaderRoutes.some((path) => location.pathname.startsWith(path)) ||
    noHeaderRegex.test(location.pathname);

  const showSidebar =
    !noSidebarRoutes.some((path) => location.pathname.startsWith(path)) &&
    !noSidebarRegex.test(location.pathname);

  return (
    <SectionWrapper>
      <ContentRow>
        <ContentCol $showSidebar={showSidebar}>
          <main className="main-content">{children}</main>
        </ContentCol>
      </ContentRow>
    </SectionWrapper>
  );
};

/* **********************************
 * STYLED COMPONENT
 ********************************** */
const SectionWrapper = styled.section`
  width: 100%;
  min-height: 100vh;
  background: ${({ theme }) => {
    const location = window.location.pathname;
    return location.startsWith("/payments") ? "white" : colors.gray50;
  }};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;

  ${({ theme }) => theme.device.mobile} {
    min-height: 100dvh;
    padding: 0;
  }
`;

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;

  ${({ theme }) => theme.device.mobile} {
    flex-direction: column;
    min-height: 100dvh;
  }
`;

const ContentCol = styled.div<{ $showSidebar: boolean }>`
  flex: 1;
  width: ${({ $showSidebar }) =>
    $showSidebar ? "calc(100% - 200px)" : "100%"};
  min-height: 100vh;
  height: auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .main-content {
    flex: 1;
    width: 100%;
    background-color: ${({ theme }) => {
      const location = window.location.pathname;
      return location.startsWith("/chewing-payments") ? "white" : colors.gray50;
    }};
    position: relative;
    height: auto;
    min-height: 0;
    padding-bottom: 0;
    ${({ theme }) => theme.device.mobile} {
      height: auto;
      min-height: 0;
      padding-bottom: 0;
    }
  }

  ${({ theme }) => theme.device.mobile} {
    width: 100%;
    min-height: 100dvh;
    padding: 0;
  }
`;

export default Layout;
